import { z } from 'zod';

export const cdekOfficesQuerySchema = z.object({
    action: z.literal('offices'),
    country_code: z.string().optional(),
    city_code: z.coerce.number().optional(),
    postal_code: z.string().optional(),
    page: z.coerce.number().optional(),
    size: z.coerce.number().optional(),
    is_handout: z.coerce.boolean().optional(),
    is_dressing_room: z.coerce.boolean().optional(),
    have_cash: z.coerce.boolean().optional(),
    have_cashless: z.coerce.boolean().optional(),
    allowed_cod: z.coerce.boolean().optional(),
    lang: z.enum(['rus', 'eng']).optional(),
    type: z.enum(['PVZ', 'POSTAMAT']).optional(),
});

export type CdekOfficesQuerySchema = z.infer<typeof cdekOfficesQuerySchema>;
